import { usePublishingContext } from "../../../contexts/PublishingContext.js";
import { echartsDarkTheme } from "../constants/echartsDarkTheme.js";
import React, { useEffect } from "react";
import { useAtalayaContext } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import * as echarts from "echarts/core";
import { DataZoomComponent, GridComponent, LegendComponent, TitleComponent, ToolboxComponent, TooltipComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { UniversalTransition } from "echarts/features";
//#region src/modules/Stats/shared/EntryTypesStackedBarChart.tsx
echarts.use([
	DataZoomComponent,
	TitleComponent,
	ToolboxComponent,
	TooltipComponent,
	GridComponent,
	LegendComponent,
	BarChart,
	CanvasRenderer,
	UniversalTransition
]);
echarts.registerTheme("THERMS Dark", echartsDarkTheme);
function EntryTypesStackedBarChart({ entriesHistogram }) {
	const { isDarkMode } = useAtalayaContext();
	const isPublishing = usePublishingContext()?.isPublishing;
	const containerRef = React.useRef(null);
	useEffect(() => {
		if (!containerRef.current || !entriesHistogram) return void 0;
		const chart = echarts.init(containerRef.current, isDarkMode ? "THERMS Dark" : "light");
		const entryTypes = /* @__PURE__ */ new Map();
		const dates = entriesHistogram.map((date, i) => {
			date.entryTypes.forEach((entryType) => {
				const entryTypeData = entryTypes.get(entryType.name) || {
					color: entryType.color,
					data: new Array(entriesHistogram.length).fill(0),
					name: entryType.name
				};
				entryTypeData.data[i] = entryType.count;
				entryTypes.set(entryType.name, entryTypeData);
			});
			return date.formattedDate;
		});
		const entryTypesSeriesData = Array.from(entryTypes.values()).map((entryType) => ({
			color: entryType.color,
			data: entryType.data,
			name: entryType.name,
			stack: "entryType",
			type: "bar"
		}));
		const option = {
			grid: { top: 110 },
			legend: {
				data: entryTypesSeriesData.map((entryType) => entryType.name),
				top: 50
			},
			series: entryTypesSeriesData,
			title: {
				left: "center",
				subtext: "Overall height of the bar represents day total",
				subtextStyle: { lineHeight: 4 },
				text: "Entry Types Per Day"
			},
			xAxis: {
				data: dates,
				type: "category"
			},
			yAxis: { type: "value" }
		};
		if (!isPublishing) {
			option.tooltip = { trigger: "axis" };
			option.toolbox = { feature: {
				dataZoom: { yAxisIndex: "none" },
				restore: {},
				saveAsImage: {}
			} };
			option.dataZoom = [{
				end: 100,
				start: 0,
				type: "inside"
			}, {
				end: 100,
				start: 0
			}];
		}
		chart.setOption(option);
		return () => chart.dispose();
	}, [
		entriesHistogram,
		containerRef.current,
		isDarkMode
	]);
	return /* @__PURE__ */ jsx("div", {
		className: "h-full w-full",
		ref: containerRef,
		style: {
			height: 500,
			width: "100%"
		}
	});
}
//#endregion
export { EntryTypesStackedBarChart };

//# sourceMappingURL=EntryTypesStackedBarChart.js.map